module.exports = __webpack_public_path__ + "static/img/wxts.930b6f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wxts.jpg
// module id = /41K
// module chunks = 1